/**
 * @overview Behaviour for the search results page.
 *
 * @module search
 */

import './filtering';
import './sortOrders';
import './refinements';
import './cuisines';
import './modals';
